/**
 * Ryan O'Dowd
 * 2024-12-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const SectionListHeader = (props: SectionListHeaderProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={[styles.container, props.backgroundColor && {backgroundColor: props.backgroundColor}]}>
      <Text style={[styles.title, props.style]}>{props.children}</Text>
    </View>
  );
};

class SectionListHeaderProps {
  children: React.ReactNode;

  style?: any;
  backgroundColor?: string;
};

export default SectionListHeader;
